<template>
  <div class="flex flex-col container mx-auto">
    <h1>Training wurde angelegt!</h1>
    <div class="mt-8 h-64">
      <img
        class="h-64"
        src="/static/undraw_game_day_ucx9.svg"
      >
    </div>
  </div>
</template>

<script>
export default {
    name: 'TrainingModify',
    async mounted () {
        console.log(this.$route.params)
    }
}
</script>

<style scoped>

</style>